import { ACTION } from './luminaire_actions';

const initialState = {
  brandList: [],
  typeList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST_LUMINAIRE_BRAND}_FULFILLED`:
      return {
        ...state,
        brandList: action.payload,
      };
    case `${ACTION.LIST_LUMINAIRE_TYPE}_FULFILLED`:
      return {
        ...state,
        typeList: action.payload,
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/references/luminaire_reducer.js